var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReplay = function SvgReplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.5 3A7.5 7.5 0 0 0 6 10.5H3C3 4.701 7.701 0 13.5 0S24 4.701 24 10.5 19.299 21 13.5 21a10.46 10.46 0 0 1-4.847-1.184l1.386-2.66A7.5 7.5 0 1 0 13.5 3",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 18 0 10.5h9z"
  })));
};
export default SvgReplay;